// Re-export from modular entry points for backward compatibility
export * from './lib/types'
export * from './client'
export * from './middleware'


// Main convenience functions
import { X402Middleware } from './middleware'
import { X402Client } from './client/fetch'
import type { FacilitatorConfig, MiddlewareOptions } from './lib'

/**
 * Main convenience function for x402 integration
 * Framework-aware middleware that works with both Express and Hono
 */

export function withX402(clientOrConfig: X402Client | FacilitatorConfig, options?: MiddlewareOptions): ReturnType<X402Middleware['createMiddleware']> | ((options: MiddlewareOptions) => ReturnType<X402Middleware['createMiddleware']>) {
  const client = clientOrConfig instanceof X402Client ? clientOrConfig : new X402Client(clientOrConfig)
  const middleware = new X402Middleware(client)

  // If options provided, return configured middleware directly
  if (options) {
    return middleware.createMiddleware(options) as ReturnType<X402Middleware['createMiddleware']>
  }

  // Return middleware creator function for consistent API
  return (middlewareOptions: MiddlewareOptions) => {
    return middleware.createMiddleware(middlewareOptions) as ReturnType<X402Middleware['createMiddleware']>
  }
}


// Default export for convenience
export default withX402
